import HttpRepository from './httpRepository';

import type { AxiosResponse } from 'axios';

export const SupportRepository = {
	getSupportUrl: async () => {
		const response: AxiosResponse<{ url: string }> = await HttpRepository.tradeshiftGo().get('/rest/support');
		return response.data;
	},
	getWorkflowConfig: ({ companyId }) =>
		HttpRepository.tradeshiftGo()
			.get(`/rest/company/${companyId}/workflowConfig/`)
			.then(response => response.data),
	setWorkflowConfig: ({ companyId, configId }) =>
		HttpRepository.tradeshiftGo().put(`/rest/company/${companyId}/workflowConfig/${configId}`),
	getWorkflowConfigs: () =>
		HttpRepository.tradeshiftGo()
			.get('/rest/workflowConfigs/')
			.then(response => response.data),
};
